<template>
  <v-list-item
      v-for="item in navigationItems"
      :key="item.title"
      :active="$route.matched.some(({ name }) => name === item.route) || item.children.some(({ route }) => $route.matched.some(({ name }) => name === route))"
      active-class="text-primary"
      variant="plain"
      :prepend-icon="item.prependIcon"
      :append-icon="item.appendIcon"
      :to="item.children.length > 0 ? (item.route? {name:item.route} : '#') : {name: item.route}"
  >
    <template v-if="item.children.length === 0">
      <v-list-item-title class="text-h6">
        {{ $t(item.title) }}
      </v-list-item-title>
    </template>
    <template v-else>
      <v-menu v-if="$vuetify.display.mdAndUp" open-on-hover open-delay="0.5" close-delay="1">
        <template v-slot:activator="{ props, isActive }">
            <span :style="{cursor: 'pointer'}" v-bind="props" class="text-h6 font-weight-regular">
              {{ $t(item.title) }} <v-icon :icon="isActive ? 'mdi-chevron-up' : 'mdi-chevron-down'"
                                           class="text-disabled"/>
            </span>
        </template>
        <v-list :class="isTopOfDocument ? 'mt-5' : 'mt-6'">
          <v-list-item
              v-for="child in item.children"
              :key="child.title"
              :active="$route.matched.some(({ name }) => name === child.route)"
              color="primary"
              :prepend-icon="child.prependIcon"
              :append-icon="child.appendIcon"
              :to="{name: child.route}"
          >
            {{ $t(child.title) }}
          </v-list-item>
        </v-list>
      </v-menu>
      <v-list-item-subtitle v-if="$vuetify.display.smAndDown" class="text-h6 pb-1 pt-2">
        {{ $t(item.title) }}
      </v-list-item-subtitle>
      <v-list v-if="$vuetify.display.smAndDown">
        <v-list-item
            v-for="child in item.children"
            :key="child.title"
            :active="$route.matched.some(({ name }) => name === child.route)"
            color="primary"
            prepend-icon="mdi-minus"
            :append-icon="child.appendIcon"
            v-bind="{to: {name: child.route}}"
        >
          {{ $t(child.title) }}
        </v-list-item>
      </v-list>
    </template>
  </v-list-item>

  <!--  <v-list-item class="pa-0" v-if="FEATURES.localePicker">-->
  <!--    <v-menu class="pa-0">-->
  <!--      <template v-slot:activator="{ props }">-->
  <!--        <v-btn-->
  <!--            v-bind="props"-->
  <!--            icon="mdi-web"-->
  <!--            variant="plain"-->
  <!--            class="pa-3 text-black"-->
  <!--            v-if="$vuetify.display.mdAndUp"-->
  <!--        >-->
  <!--        </v-btn>-->
  <!--        <v-btn-->
  <!--            v-bind="props"-->
  <!--            variant="text"-->
  <!--            v-else-if="$vuetify.display.smAndDown"-->
  <!--            append-icon="mdi-web"-->
  <!--        >-->
  <!--          Language-->
  <!--        </v-btn>-->
  <!--      </template>-->

  <!--      <v-list>-->
  <!--        <v-list-item-->
  <!--            v-for="(code, key) of LOCALES"-->
  <!--            :key="key"-->
  <!--            @click="$i18n.locale = key.toString()"-->
  <!--            :active="$i18n.locale === key"-->
  <!--            :prepend-icon="`fi fi-${key === 'en' ? 'us' : key}`"-->
  <!--        >-->
  <!--          <v-list-item-title>-->
  <!--            {{ key.toUpperCase() }}-->
  <!--          </v-list-item-title>-->
  <!--        </v-list-item>-->
  <!--      </v-list>-->
  <!--    </v-menu>-->
  <!--  </v-list-item>-->
</template>
<script setup lang="ts">
import {computed} from 'vue';
import {useDisplay} from "vuetify";
import {MainNavigation} from "@/keys";
import data_get from 'lodash/get'


defineEmits(['click-item'])

const display = useDisplay();

const isTopOfDocument = true;
const fontSize = 10;

interface NavigationItem {
  title: string;
  route: string;
  icon: string | null;
  children: NavigationItem[];
  prependIcon?: string;
  appendIcon?: string;
}

const mapNavigationItem = (item: Record<string, string | [] | null>): NavigationItem => {
  return {
    ...item,
    title: data_get(item, 'titleKey', null),
    route: data_get(item, 'routeName', null),
    icon: data_get(item, 'icon', null),
    prependIcon: display.smAndDown ? data_get(item, 'prependIcon', null) : null,
    appendIcon: display.mdAndUp ? data_get(item, 'appendIcon', null) : null,
    children: (data_get(item, 'children', []) as Record<string, any>[]).map(mapNavigationItem),
  } as NavigationItem;
};

//@ts-ignore
const navigationItems = computed(() => MainNavigation.map(mapNavigationItem));

</script>
